module.exports = __webpack_public_path__ + "img/ic-chevron-down-black.2ed74a99.svg";